/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
    Select,
    MenuItem,
    AppBar,
    Toolbar,
    Typography,
    RadioGroup,
    Radio,
    FormControlLabel,
    FormLabel,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function TeacherEdit(props) {
    const { login, onClosePop, seq } = props;
    const token = localStorage.getItem("token");
    const [centers, setCenters] = useState([]);
    const [tcid, setTcid] = useState('');
    const [tcd, setTcd] = useState("");
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [pass1, setPass1] = useState("");
    const [active, setActive] = useState("");
    const [grade, setGrade] = useState("");

    // 데이타폼
    const [data, setData] = useState({
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
    });

    const onHandleData = (e) => {
        setData((state) => {
            return { ...state, [e.target.name]: e.target.value };
        });
    };

    const onSubmit = async () => {

        pr('seq=' + seq);
        pr('tcid=' + tcid);
        pr('name=' + name);
        pr('pass1=' + pass1);
        pr('active=' + active);

        let result = await axios.post(
            configState.api + "/gympass_admin/teacher_edit",
            {
                token: token,
                cid: login.cid,
                level: login.level,
                mcd: login.mcd,
                seq: seq,
                tcid: tcid,
                name: name,
                pass1: pass1,
                active: active,
                grade: grade,
            }
        );
        if (result.data.success !== 1) {
            Swal.fire(result.data.msg);
            return;
        } else {
            Swal.fire({ title: "수정되었습니다.", showCloseButton: true }).then(
                (result) => {
                    onClosePop();
                }
            );
        }
    };

    const load_data = async () => {
        let result = await axios.post(
            configState.api + "/gympass_admin/teacher_one",
            {
                token: token,
                cid: login.cid,
                level: login.level,
                mcd: login.mcd,
                seq: seq,
            }
        );
        if (result.data.success === 1) {
            setName(result.data.row.name);
            setPhone(result.data.row.phone);
            setData((state) => {
                return { ...state, tcid: result.data.row.tcid };
            });
            setTcd(result.data.row.tcd);
            setTcid(result.data.row.tcid);
            setActive(result.data.active);
            setGrade(result.data.grade);
        } else {
            Swal.fire(result.data.msg);
            return;
        }
    };

    const onDeleteClick = () => {
        Swal.fire({
            title: "삭제하시겠습니까?",
            showConfirmButton: true,
            showCancelButton: true,
        })
            .then(async (result) => {
                if (result.isConfirmed) {
                    let result = await axios.post(
                        configState.api + "/gympass_admin/teacher_del",
                        {
                            token: token,
                            cid: login.cid,
                            level: login.level,
                            mcd: login.mcd,
                            seq: seq,
                            tcid: tcid,
                            active: active
                        }
                    );
                    if (result.data.success === 1) {
                        onClosePop();
                    } else {
                        Swal.fire(result.data.msg);
                    }
                }
            })
            .catch((e) => alert(e));
    };

    useEffect(() => {
        load_data();
    }, [seq]);

    return (
        <Box>
            <Box
                css={css`
          padding: 20px 60px;
        `}
            >

                {/* 센터명 */}
                <CenterSelect
                    login={login}
                    tcidParent={tcid}
                    setTcidParent={setTcid}
                />

                {/* 고객명 */}
                <Box
                    display="flex"
                    alignItems="center"
                    sx={{ pt: 1 }}
                >
                    <TextField
                        name="name"
                        label="강사명"
                        size="small"
                        sx={{
                            width: "180px",
                        }}
                        autoComplete="off"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    ></TextField>
                    <Box sx={{ pl: 1 }}>{tcd}</Box>
                </Box>

                {/* 연락처 */}
                <Box
                    css={css`
            margin-top: 10px;
          `}
                    display="flex"
                    alignItems="center"
                >
                    <TextField
                        InputProps={{
                            readOnly: true,
                        }}
                        name="phone"
                        label="연락처"
                        size="small"
                        sx={{
                            width: "180px",
                        }}
                        autoComplete="off"
                        value={phone}
                    ></TextField>
                    <Box sx={{ ml: 1 }}>(변경불가)</Box>
                </Box>

                {/* 비밀번호 */}
                <Box
                    display="flex"
                    alignItems="center"
                    css={css`
            margin-top: 10px;
          `}
                >
                    <TextField
                        type="password"
                        name="pass1"
                        label="비밀번호"
                        size="small"
                        sx={{
                            width: "180px",
                        }}
                        autoComplete="off"
                        value={pass1}
                        onChange={(e) => setPass1(e.target.value)}
                    ></TextField>
                    <Box sx={{ ml: 1 }}>(변경시 입력) 4~12자리 영문과 숫자로 입력</Box>
                </Box>

                {/* 강사등급 */}
                <FormControl sx={{ width: '180px', marginTop: '10px' }} size="small">
                    <InputLabel>강사등급</InputLabel>
                    <Select
                        name="education"
                        label="강사등급"
                        onChange={(e) => setGrade(e.target.value)}
                        value={grade}
                    >
                        <MenuItem value="점장">점장</MenuItem>
                        <MenuItem value="트레이너">트레이너</MenuItem>
                    </Select>
                </FormControl>

                {/* 강사수업여부 */}
                <FormControl
                    fullWidth
                    css={css`
            margin-top: 10px;
          `}
                >
                    <FormLabel>강사수업여부</FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="active"
                        onChange={(e) => setActive(e.target.value)}
                        value={active}
                    >
                        <FormControlLabel value="Y" control={<Radio />} label="예" />
                        <FormControlLabel value="N" control={<Radio />} label="아니오" />
                    </RadioGroup>
                </FormControl>

                <Box
                    css={css`
            text-align: center;
            margin-top: 30px;
          `}
                >
                    <Button variant="contained" onClick={onSubmit}>
                        수정완료
                    </Button>

                    <Button
                        variant="contained"
                        css={css`
              margin-left: 10px;
            `}
                        onClick={onClosePop}
                    >
                        취소
                    </Button>
                    {login.level === 500 &&
                    <Button
                        variant="contained"
                        color="warning"
                        css={css`
              margin-left: 10px;
            `}
                        onClick={onDeleteClick}
                    >
                        삭제
                    </Button>
                    }
                </Box>
            </Box>
        </Box>
    );
}

export default TeacherEdit;
